module.exports = __webpack_public_path__ + "static/logo_loop-9eeedcef54a28ab187023e45eb9a253c.mp4";